var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats"},_vm._l((_vm.stats),function(ref){
var statId = ref.id;
var values = ref.value;
return _c('div',{key:statId},[_c('category-widget',{attrs:{"items":values.map(function (v) { return (Object.assign({}, v, {name: v.id})); }),"filter-type":'simple-filter'},on:{"filter":function($event){return _vm.$emit('update:selectedSegment', $event)}}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }